// extracted by mini-css-extract-plugin
module.exports = {"flowableOrgSearch":"src-components-flowable-FlowableOrgSearch-styles___flowableOrgSearch"};